import React from 'react'

interface IProps {
	className?: string
	placeholder: string
	type?: 'submit' | 'button' | undefined
	variant?: 'outline' | 'arrows' | 'clear' | 'form-btn'
	width?: string
	height?: string
	left?: HTMLElement | React.ReactElement
	right?: HTMLElement | React.ReactElement
	id?: string
	onClick?: () => void
}

export default function Btn(props: IProps): React.ReactElement {
	return (
		<div className={props.className ?? 'btn'}>
			<button
				className={props.variant ?? 'default'}
				style={{ width: props.width, height: props.height }}
				type={props.type}
				onClick={props.onClick}
				id={props.id}
			>
				<>
					{props.left}
					{props.placeholder}
					{props.right}
				</>
			</button>
		</div>
	)
}
